var React = require('react');

function MoreVertical (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z"}));
}

MoreVertical.defaultProps = {"fill":"currentColor","version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MoreVertical;

MoreVertical.default = MoreVertical;
